export default function useMaintenanceMode() {
  const { t } = useI18n({
    messages: {
      en: {
        title: 'RVezy - Offline for maintenance, check back later',
      },
      fr: {
        title: 'RVezy - Hors ligne pour maintenance, revenez plus tard',
      },
    },
  })

  const { routeBaseName } = useBaseName()

  const { isFeatureEnabled } = useExperiment()
  const maintenanceMode = computed(() => {
    return isFeatureEnabled('maintenanceMode') && !['experiments'].includes(routeBaseName.value)
  })

  if (maintenanceMode.value) {
    useHead({
      title: t('title'),
    })
  }

  return {
    maintenanceMode,
  }
}
